"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconCheckmark = _interopRequireDefault(require("../../../shared/icons/icon-checkmark.svg"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListItem = function ListItemComponent(_ref) {
  var listStyle = _ref.listStyle,
      listItem = _ref.listItem,
      dataClient = _ref.dataClient,
      counter = _ref.counter;
  var listItemTitle = listItem.list_item_title,
      listItemBody = listItem.list_item_body;
  var counterStyleMap = {
    Numbered: {
      counterClass: 'content-page__list-item-counter--numbered',
      counterElement: counter
    },
    Bulleted: {
      counterClass: 'content-page__list-item-counter--bulleted',
      counterElement: /*#__PURE__*/_react["default"].createElement(_iconCheckmark["default"], {
        className: "content-page__list-item-counter__icon"
      })
    }
  };
  var _counterStyleMap$list = counterStyleMap[listStyle],
      counterElement = _counterStyleMap$list.counterElement,
      counterClass = _counterStyleMap$list.counterClass;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "content-page__list-item"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(counterClass)
  }, counterElement), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__list-item-title"
  }, dataClient.renderText(listItemTitle)), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__list-item-body",
    content: listItemBody
  }));
};
/* eslint-disable camelcase */


ListItem.propTypes = {
  listStyle: _propTypes["default"].string.isRequired,
  listItem: _propTypes["default"].shape({
    list_item_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    list_item_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
  }).isRequired,
  dataClient: _propTypes["default"].shape({}).isRequired,
  counter: _propTypes["default"].string
};
ListItem.defaultProps = {
  counter: ''
};
var _default = ListItem;
exports["default"] = _default;